import script from "./DataDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./DataDashboard.vue?vue&type=script&setup=true&lang=js"

import "./DataDashboard.vue?vue&type=style&index=0&id=691b3eed&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/spa-headless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-691b3eed"]])

export default __exports__